const DetailsCard = ({ children, title, className }) => {
  return (
    <section className="mb-10 min-w-full rounded-lg border border-solid border-gray-light">
      <h2
        className={`${className} border-b border-solid border-gray-light bg-opacity-90 py-4 px-5 font-satoshi-bold text-base tracking-wide md:p-7 md:py-4`}
      >
        {title}
      </h2>
      <div className="my-4 p-7 font-satoshi-medium lg:p-12">{children}</div>
    </section>
  );
};

export default DetailsCard;
